import type { ReactNode } from 'react'

interface ChipProps {
  color?: string
  emphasis?: 'quiet' | 'filled'
  children: ReactNode
  onClick?: () => void
}

export function Chip({ color, emphasis = 'quiet', children, onClick }: ChipProps) {
  const bg = emphasis === 'filled' ? color ?? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.05)'
  const border = emphasis === 'quiet' ? `1px solid ${color ?? 'rgba(255,255,255,0.16)'}` : '0'
  const textColor = emphasis === 'filled' ? '#0B0F0E' : color ?? '#F4EFE7'
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-caption font-medium transition-colors duration-fast"
      style={{ background: bg, border, color: textColor }}
    >
      {children}
    </button>
  )
}
